import { customerReturns, type CustomerReturnItem, formatMoney } from "@/mocks/managerWorkspace";

export default function CustomerReturnsWidget() {
  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-[#E8F5E9] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-arrow-go-back-line text-[12px] text-[#2D6A4F]"></i>
          <span className="text-[11px] font-semibold text-[#2D6A4F]">Возвраты от покупателей</span>
        </div>
        <span className="text-[11px] font-bold text-[#2D6A4F]">{customerReturns.length}</span>
      </div>
      <div className="flex-1 overflow-auto">
        <table className="w-full text-[10px]">
          <thead>
            <tr className="bg-[#E8F5E9]/50 text-[#2D6A4F]">
              <th className="text-left px-2 py-1 font-medium">Клиент</th>
              <th className="text-left px-2 py-1 font-medium">Документ</th>
              <th className="text-left px-2 py-1 font-medium">Товар</th>
              <th className="text-left px-2 py-1 font-medium">Кол-во</th>
              <th className="text-right px-2 py-1 font-medium">Сумма</th>
              <th className="text-left px-2 py-1 font-medium">Статус</th>
            </tr>
          </thead>
          <tbody>
            {customerReturns.map((r: CustomerReturnItem, i: number) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#E8F5E9]/40 transition-colors">
                <td className="px-2 py-1.5 text-[#2D2D2D]">{r.client}</td>
                <td className="px-2 py-1.5 text-[#666666]">{r.returnDoc}</td>
                <td className="px-2 py-1.5 text-[#666666]">{r.product}</td>
                <td className="px-2 py-1.5 text-[#666666]">{r.qty}</td>
                <td className="px-2 py-1.5 text-[#2D2D2D] text-right font-medium">{formatMoney(r.amount)}</td>
                <td className="px-2 py-1.5">
                  <span className={`px-1.5 py-0.5 rounded text-[9px] font-medium ${r.statusColor}`}>{r.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1.5 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#E8F5E9] px-2 py-0.5 rounded transition-colors cursor-pointer whitespace-nowrap">
          Все возвраты
        </button>
      </div>
    </div>
  );
}